const LIVE_HOST = {
  dev: "ke-dev.huaban.com",
  fat: "ke-fat.huaban.com",
  stage: "ke-stage.huaban.com",
  prod: "ke.huaban.com",
};

const MOBILE_HOST = {
  dev: "m-dev.huaban.com",
  fat: "m-fat.huaban.com",
  stage: "m-stage.huaban.com",
  prod: "m.huaban.com",
};

const GAODING_HOST = {
  dev: "dev.gaoding.com",
  fat: "fat.gaoding.com",
  stage: "stage.gaoding.com",
  prod: "gaoding.com",
};

const GAODING_UMS_HOST = {
  dev: "ums.dev.gaoding.com",
  fat: "ums-fat.gaoding.com",
  stage: "ums-stage.gaoding.com",
  prod: "ums.gaoding.com",
};

const GAODING_EDIT_HOST = {
  dev: "gd-dev.huaban.com",
  fat: "gd-fat.huaban.com",
  stage: "gd-stage.huaban.com",
  prod: "gd.huaban.com",
};

const HUABAN_ART_HOST = {
  dev: "dev.gaoding.art",
  fat: "fat.gaoding.art",
  stage: "stage.gaoding.art",
  prod: "www.gaoding.art",
};

const env = process.env.NEXT_PUBLIC_DEPLOY_ENV || "prod";

/** ke.huaban.com */
export const liveHost = LIVE_HOST[env];
/** m.huaban.com */
export const mobileHost = MOBILE_HOST[env];
/**gaoding.com */
export const gaodingHost = GAODING_HOST[env];
/** ums.gaoding.com */
export const gaodingUmsHost = GAODING_UMS_HOST[env];
/** gd.huaban.com */
export const gaodingEditHost = GAODING_EDIT_HOST[env];
/** www.gaoding.art */
export const huabanArtHost = HUABAN_ART_HOST[env];

/** 会员权益页面 */
export const VIP_RIGHT_PAGE = `https://${gaodingEditHost}/admin/orgs`;
/** 下载记录页面 */
export const MATERIAL_DOWNLOAD_RECORD_PAGE = `https://${gaodingEditHost}/admin/material-download-record`;
/** 订单发票页面 */
export const ORDER_INVOICE_PAGE = `https://${gaodingEditHost}/admin/order-invoice`;
/** 授权主体页面 */
export const VIP_CERT_PAGE = `https://${gaodingEditHost}/admin/license?type=material_vip`;
/** 成员管理页面 */
export const MEMBER_MANAGEMENT_PAGE = `https://${gaodingEditHost}/admin/members`;
